import {AfterSignUpGuild, Round} from "./styles";
import React from "react";

export default function Done() {
  return (
      <article>
        <AfterSignUpGuild>
          <Round />
          <div className={'tit'}>Oaple-Media 가입을 진심으로 환영합니다!</div>
          <div className={'txt'}>로그인 후 매체를 등록하고 최적화된 광고 지면 관리를 바로 시작해보세요.</div>
        </AfterSignUpGuild>
      </article>
  )
}
